import { useState, useMemo } from "react";

export const usePermissionFilters = ({ permissions }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const filteredPermissions = useMemo(() => {
    if (!searchTerm) {
      return permissions;
    }

    const term = searchTerm.toLowerCase();
    return permissions.filter((permission) => {
      return (
        (permission.name && permission.name.toLowerCase().includes(term)) ||
        (permission.id && String(permission.id).toLowerCase().includes(term)) ||
        (permission.description &&
          permission.description.toLowerCase().includes(term))
      );
    });
  }, [permissions, searchTerm]);
  const noPermissions = permissions.length === 0;
  const noResults = permissions.length > 0 && filteredPermissions.length === 0;

  return {
    searchTerm,
    setSearchTerm,
    filteredPermissions,
    noPermissions,
    noResults,
  };
};

export default usePermissionFilters;
